import moment from 'moment';
import 'moment/locale/ko';
import { useEffect, useState } from 'react';
import { getMAJAD040 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_STATISTICAL } from '../../../shared/constants/app';
const MAJAD040 = () => {
    moment.locale('ko');
    const [data, setData] = useState({
        dentalJobHighlight: [],
        dentalJobColor: [],
        dentalJobIcon: [],
        dentalJobHighlight2: [],
        dentalJobColor2: [],
        dentalJobIcon2: [],
    });
    const [timeGetData, setTimeGetData] = useState('');
    useEffect(() => {
        getMAJAD040()
            .then((response) => {
                setData(response.data);
                setTimeGetData(moment().format('YYYY-MM-DD a hh:mm:ss'));
            })
            .catch((error) => console.log(error));
    }, []);

    return (
        <>
            <div className="container-fluid container statis-page">
                <div className="content wrap">
                    <SideMenu menu={MENU_STATISTICAL} />
                    <div className=" content-right" style={{ marginTop: 20 }}>
                        <div className="title">강조상품집계현황</div>
                        <div className="table-padding-5">
                            <div className="count-item red" style={{ color: '#ff0000' }}>
                                ※ 하기 집계수량은 해당페이지를 조회하는 일자기준(실시간, {timeGetData})입니다.
                            </div>
                        </div>
                        <div className="group-table">
                            <div className="title">※ 덴탈잡</div>
                            <div className="group-child-table">
                                <div className="child-title">* 하이라이트 강조</div>
                                <table className="table table-gray w50">
                                    <thead>
                                        <tr>
                                            <th>금일신청</th>
                                            <th>누적신청</th>
                                            <th>금일서비스</th>
                                            <th>금일종료</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {data?.dentalJobHighlight &&
                                                data?.dentalJobHighlight.length > 0 &&
                                                data?.dentalJobHighlight?.map((value, index) => (
                                                    <td key={index}>{value}</td>
                                                ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="group-child-table">
                                <div className="child-title">* 컬러 강조</div>
                                <table className="table table-gray w50">
                                    <thead>
                                        <tr>
                                            <th>금일신청</th>
                                            <th>누적신청</th>
                                            <th>금일서비스</th>
                                            <th>금일종료</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {data?.dentalJobColor &&
                                                data?.dentalJobColor.length > 0 &&
                                                data?.dentalJobColor?.map((value, index) => (
                                                    <td key={index}>{value}</td>
                                                ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="group-child-table">
                                <div className="child-title">* 아이콘 강조</div>
                                <table className="table table-gray pd-8">
                                    <thead>
                                        <tr>
                                            <th>금일신청(주목)</th>
                                            <th>금일신청(HOT)</th>
                                            <th>금일신청(전체)</th>
                                            <th>누적신청(주목)</th>
                                            <th>누적신청(HOT)</th>
                                            <th>누적신청(전체)</th>
                                            <th>금일서비스(주목)</th>
                                            <th>금일서비스(HOT)</th>
                                            <th>금일서비스(전체)</th>
                                            <th>금일종료(주목)</th>
                                            <th>금일종료(HOT)</th>
                                            <th>금일종료(전체)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {data?.dentalJobIcon &&
                                                data?.dentalJobIcon.length > 0 &&
                                                data?.dentalJobIcon?.map((value, index) => (
                                                    <td key={index}>{value}</td>
                                                ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="group-table">
                            <div className="group-child-table">
                                <div className="child-title">* 하이라이트 강조2</div>
                                <table className="table table-gray w50">
                                    <thead>
                                        <tr>
                                            <th>금일신청</th>
                                            <th>누적신청</th>
                                            <th>금일서비스</th>
                                            <th>금일종료</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {data?.dentalJobHighlight2 &&
                                                data?.dentalJobHighlight2.length > 0 &&
                                                data?.dentalJobHighlight2?.map((value, index) => (
                                                    <td key={index}>{value}</td>
                                                ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="group-child-table">
                                <div className="child-title">* 컬러 강조2</div>
                                <table className="table table-gray w50">
                                    <thead>
                                        <tr>
                                            <th>금일신청</th>
                                            <th>누적신청</th>
                                            <th>금일서비스</th>
                                            <th>금일종료</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {data?.dentalJobColor2 &&
                                                data?.dentalJobColor2.length > 0 &&
                                                data?.dentalJobColor2?.map((value, index) => (
                                                    <td key={index}>{value}</td>
                                                ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="group-child-table">
                                <div className="child-title">* 아이콘 강조2</div>
                                <table className="table table-gray pd-8">
                                    <thead>
                                        <tr>
                                            <th>금일신청(주목)</th>
                                            <th>금일신청(HOT)</th>
                                            <th>금일신청(전체)</th>
                                            <th>누적신청(주목)</th>
                                            <th>누적신청(HOT)</th>
                                            <th>누적신청(전체)</th>
                                            <th>금일서비스(주목)</th>
                                            <th>금일서비스(HOT)</th>
                                            <th>금일서비스(전체)</th>
                                            <th>금일종료(주목)</th>
                                            <th>금일종료(HOT)</th>
                                            <th>금일종료(전체)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {data?.dentalJobIcon2 &&
                                                data?.dentalJobIcon2.length > 0 &&
                                                data?.dentalJobIcon2?.map((value, index) => (
                                                    <td key={index}>{value}</td>
                                                ))}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default MAJAD040;
